import { EventEmitter } from '@angular/core';
import { Component, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'gb-action-button',
  templateUrl: './getbetter-action-button.component.html',
  styleUrls: ['./getbetter-action-button.component.css']
})
export class GetbetterActionButtonComponent implements OnInit {

  @Input() isLoading: boolean = false;
  @Input() text: string = "Enter button text"
  @Input() iconClass: string = "";
  @Input() whenDisabled: boolean = false;
  @Output() onClick = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {}

  onClickButton(event: any){
    this.onClick.emit(event);
  }

}
